export const hideSwishCardByfundraiserId = (id) => {
  const fundraisersToHide = [
    '1cfc46a4-d56f-46a9-8846-a1861a64341a',
    'c84fd3ee-7cc1-43dc-bc5c-9a401e19e451',
    '34fc1f1d-771a-4d52-b355-21320e476a86',
  ];
  return fundraisersToHide.includes(id);
};
